import * as types from '../actions/preferences/types';

const INITIAL_STATE = {};

export default function userReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.USER_PREFERENCES:

      return action.payload;

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js